import { render, staticRenderFns } from "./EditCustomDoc.vue?vue&type=template&id=7b4fec22&scoped=true&"
import script from "./EditCustomDoc.vue?vue&type=script&lang=js&"
export * from "./EditCustomDoc.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomDoc.vue?vue&type=style&index=0&id=7b4fec22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4fec22",
  null
  
)

export default component.exports